module.exports = __webpack_public_path__ + "static/vsl-c42411975281af4ddaa2842fdca8d8d8.png";